export default __webpack_public_path__ + "static/media/default image@2x.3313b361.png";